<div class="scrollable-container" [markScrolled]="FILTER">
  <!-- the menu filter -->
  <div class="menu-filter" #FILTER>
    <input
      type="text"
      name="_menuFilterInput"
      class="menu-filter-input"
      [ngClass]="[
        _menuFilterInput ? '_active' : '',
        _menuFilterInput && !(filteredMenuItems | keywordFilter: _menuFilterInput : 'label').length ? '_error' : '',
      ]"
      (keyup)="filterMenuItems($event)"
      [(ngModel)]="_menuFilterInput"
      />
      <i class="search-i"></i>
      @if (!_menuFilterInput) {
        <span class="menu-filter-placeholder">{{ 'COMMON.SEARCH_IN_MENU' | translate }}</span>
      }
    </div>

    <!-- menu => Filtered -->
    @if (_menuFilterInput) {
      <ul class="filtered-menu">
        @for (item of filteredMenuItems | keywordFilter: _menuFilterInput : 'label'; track item) {
          <li>
            <a routerLink="{{ item.href }}" routerLinkActive="active-item">
              {{ item.label }}
            </a>
          </li>
        }
      </ul>
    }

    <!-- menu => Default -->
    @if (!_menuFilterInput) {
      @for (definition of menuItems; track definition; let i = $index) {
        @if (definition.hasMenu) {
          <mat-accordion>
            <mat-expansion-panel
              hideToggle
              class="expansion-panel"
              routerLinkActive="active-item"
              #rla="routerLinkActive"
              (opened)="setMenuActiveState(i)"
              [expanded]="menuActiveState == i || rla.isActive"
              >
              <mat-expansion-panel-header>
                <a class="display-flex">
                  <mat-panel-title>
                    <div class="menu-header--icon">
                      @if (definition.hasUnreadMessages) {
                        <div class="unread-messages unread-messages--parent-item"></div>
                      }
                      @if (definition.updates) {
                        <div class="updates updates--parent-item">{{ definition.updates }}</div>
                      }
                      <mat-icon aria-hidden="false"><i class="icon {{ definition.icon }}"></i></mat-icon>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div class="menu-header--title">{{ definition.header | translate }}</div>
                  </mat-panel-description>
                </a>
              </mat-expansion-panel-header>
              <ul class="dashboard-submenu">
                @for (item of definition.menuDefinition; track item; let i = $index) {
                  <li>
                    @if (definition.hasUnreadMessages) {
                      <div class="unread-messages"></div>
                    }
                    @if (definition.updates && i == 0) {
                      <div class="updates">{{ definition.updates }}</div>
                    }
                    <a routerLink="{{ item.href }}" routerLinkActive="active-subitem" class="dashboard-submenu__item">
                      <span class="menu-item-caption">{{ item.caption | translate }}</span>
                    </a>
                  </li>
                }
              </ul>
              <!-- <app-dashboard-new-menu-item [definition]="definition" [viewType]="1"></app-dashboard-new-menu-item> -->
            </mat-expansion-panel>
          </mat-accordion>
        }
        @if (!definition.hasMenu) {
          <div
            class="mat-expansion-panel-header"
            routerLinkActive="active-item"
            [routerLinkActiveOptions]="{ exact: true }"
            >
            <span class="mat-content">
              <a routerLink="{{ definition.href }}" routerLinkActive="active-item" class="display-flex">
                <mat-panel-title>
                  <div class="menu-header--icon">
                    <mat-icon aria-hidden="false"><i class="icon {{ definition.icon }}"></i></mat-icon>
                  </div>
                </mat-panel-title>
                <mat-panel-description>
                  <div class="menu-header--title">{{ definition.header | translate }}</div>
                </mat-panel-description>
              </a>
            </span>
          </div>
        }
      }
    }
  </div>
